import { ProjectDTO, ProjectPhase } from '../app/core/models/project-model';

export const PROJECT: ProjectDTO[] = [
  {
    contractNr: '2024-0315',
    displayName: 'DB Brückenneubau A7',
    phase: ProjectPhase.IN_BUILD,
    department: { kstId: 531, displayName: 'Digitale Dienste & Software-Entwicklung' },
  },
  {
    contractNr: '2024-0528',
    displayName: 'Siemens Anlagenbau Elektrotechnik',
    phase: ProjectPhase.IN_BUILD,
    department: { kstId: 532, displayName: 'Elektrotechnik & Infrastruktur' },
  },
  {
    contractNr: '2023-1102',
    displayName: 'Stadtwerke München Versorgungsleitungen',
    phase: ProjectPhase.INACTIVE,
    department: { kstId: 533, displayName: 'Versorgungstechnik' },
  },
  {
    contractNr: '2023-0819',
    displayName: 'Autobahn GmbH Straßenbau',
    phase: ProjectPhase.INACTIVE,
    department: { kstId: 534, displayName: 'Straßen- & Tiefbau' },
  },
  {
    contractNr: '2024-0201',
    displayName: 'Flughafen Hamburg Infrastruktur',
    phase: ProjectPhase.IN_BUILD,
    department: { kstId: 535, displayName: 'Infrastruktur & Hochbau' },
  },
  {
    contractNr: '2024-0710',
    displayName: 'RMV Verkehrsverbund Erweiterung',
    phase: ProjectPhase.IN_DOCUMENTATION,
    department: { kstId: 536, displayName: 'Verkehrsingenieurbau' },
  },
  {
    contractNr: '2023-0603',
    displayName: 'Berliner Wasserbetriebe Kanalbau',
    phase: ProjectPhase.INACTIVE,
    department: { kstId: 537, displayName: 'Wasserwirtschaft & Umwelttechnik' },
  },
  {
    contractNr: '2024-0422',
    displayName: 'E.ON SE Netzausbau',
    phase: ProjectPhase.IN_DESIGN,
    department: { kstId: 538, displayName: 'Energietechnik' },
  },
  {
    contractNr: '2024-0914',
    displayName: 'Bayer. Staatsbauverwaltung Hochbau',
    phase: ProjectPhase.IN_BUILD,
    department: { kstId: 539, displayName: 'Hochbau & Gebäudetechnik' },
  },
  {
    contractNr: '2025-0107',
    displayName: 'Hamburger Hochbahn Streckenerweiterung',
    phase: ProjectPhase.IN_DESIGN,
    department: { kstId: 540, displayName: 'Schieneninfrastruktur' },
  },
];
